import React, { useState, useRef, useEffect } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { User } from "lucide-react";

const DashboardLayout = () => {
  const [openMenus, setOpenMenus] = useState({ master: false });

  const toggleMenu = (menuName) => {
    setOpenMenus((prev) => ({ ...prev, [menuName]: !prev[menuName] }));
  };
  
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const email = storedUser?.email;
    const level = storedUser?.level;

    fetch(`${process.env.REACT_APP_BASE_URL}api/users/search?email=${encodeURIComponent(email)}`)
        .then((res) => res.json())
        .then((data) => {
            if (data.status === "success") {
            setUser(data.data);
            } else {
            console.error(data.message);
            }
        })
        .catch((err) => console.error(err));
  }, []);

  const location = useLocation();
  const pageTitles = {
    "/rf": "List Form Ajuan",
    "/create": "Form Ajuan",
    "/dashboard": "Dashboard",
    "/profile": "Profile",
    "/events": "Master Data Event",
    "/vendors": "Master Data Vendor",
    "/approval": "Master Data Approval",
    "/bank": "Master Data Akun Bank",
    "/account": "Pengaturan Akun",
    "/filteredRf": "Hasil Filter Tanggal",
  };
  
  const currentTitle = pageTitles[location.pathname] || "";

  const isActive = (path) => {
    return location.pathname === path;
  };

  // close dropdown when clicked outside
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (!storedUser) {
      navigate("/login"); // Jika tidak ada user, arahkan ke login
    } else {
      setUser(storedUser);
    }
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSignOut = () => {
    // logika signout di sini
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-gray-100">
      {/* Sidebar */}
      <aside
        className={`bg-white text-black w-64 flex-col absolute md:relative z-50 md:flex shadow-2xl ${
          sidebarOpen ? "flex" : "hidden"
        }`}
      >
        <div className="flex items-center gap-2 p-4 border-b border-gray-700">
          <img src="/riiv2/images/rii-icon.png" alt="Company Logo" className="h-8" />
          <span className="text-md font-bold">Ruang Inspirasi Indonesia</span>
        </div>
        <nav className="flex-1 p-4 space-y-2">
            {(["1"].includes(user?.group_id ?? "")) && (
            <Link
              to="/dashboard"
              className={`block py-2 px-4 rounded hover:bg-gray-300 hover:text-black ${isActive("/dashboard") ? "bg-gray-600 font-semibold text-white" : ""
              }`}
              onClick={() => setSidebarOpen(false)}
            >
              Dashboard
            </Link>
            )}
            <Link
              to="/"
              className={`block py-2 px-4 rounded hover:bg-gray-300 hover:text-black ${isActive("/") ? "bg-gray-900 font-semibold text-white" : ""
              }`}
              onClick={() => setSidebarOpen(false)}
            >
              Form Ajuan
            </Link>
            {(["1"].includes(user?.group_id ?? "")) && (
              <button
                onClick={() => toggleMenu("master")}
                className="w-full text-left py-2 px-4 rounded hover:bg-gray-300 hover:text-black flex justify-between items-center"
              >
                Master Data
                <span>{openMenus.master ? "▾" : "▸"}</span>
              </button>
            )}
              {openMenus.master && (
                <ul className="pl-6 mt-1 space-y-1 text-sm text-gray-600">
                  <li>
                    <Link to="/events" className={`block py-1 px-2 rounded hover:bg-gray-300 hover:text-black ${isActive("/events") ? "bg-gray-900 font-semibold text-white" : ""
                }`} onClick={() => setSidebarOpen(false)}>
                      Event
                    </Link>
                  </li>
                  <li>
                    <Link to="/vendors" className={`block py-1 px-2 rounded hover:bg-gray-300 hover:text-black ${isActive("/vendors") ? "bg-gray-900 font-semibold text-white" : ""
                }`} onClick={() => setSidebarOpen(false)}>
                      Vendor
                    </Link>
                  </li>
                  <li>
                    <Link to="/approval" className={`block py-1 px-2 rounded hover:bg-gray-300 hover:text-black ${isActive("/approval") ? "bg-gray-900 font-semibold text-white" : ""
                }`} onClick={() => setSidebarOpen(false)}>
                      Approval
                    </Link>
                  </li>
                  <li>
                    <Link to="/bank" className={`block py-1 px-2 rounded hover:bg-gray-300 hover:text-black  ${isActive("/bank") ? "bg-gray-900 font-semibold text-white" : ""
                }`} onClick={() => setSidebarOpen(false)}>
                      Akun Bank
                    </Link>
                  </li>
                </ul>
              )}
            {(["1"].includes(user?.group_id ?? "")) && (
            <Link
              to="/account" className={`block py-2 px-4 rounded hover:bg-gray-300 hover:text-black  ${isActive("/account") ? "bg-gray-900 font-semibold text-white" : ""
                }`}
                onClick={() => setSidebarOpen(false)}
            >
              Pengaturan Akun
            </Link>
            )}
          
          </nav>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Navbar */}
        <header className="bg-gray-800 shadow px-4 py-4 flex justify-between items-center md:px-6 relative">
          <div className="flex items-center gap-4">
            {/* Mobile Toggle */}
            <button
              className="md:hidden text-gray-700 focus:outline-none"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                {sidebarOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>

            {/* Page Title */}
            <h1 className="text-lg font-semibold text-white">{currentTitle}</h1>
          </div>

          {/* User Icon + Dropdown */}
          <div className="relative flex items-center justify-items-center gap-4 flex-col" ref={dropdownRef}>  
            <div className="gap-4">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="focus:outline-none bg-gray-200 p-1 rounded hover:bg-gray-600 "
                >
                <User className="h-6 w-6 text-gray-600 hover:text-white" />
              </button>
              {dropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white border rounded-md shadow-md z-50">
                  <div className={`px-4 py-2 text-sm text-gray-700 rounded bg-green-200`}>
                    {user.level === "finance"
                      ? "Finance"
                      : user.level === "admin"
                      ? "Administrator"
                      : user.level === "event"
                      ? "Event"
                      : "Unknown"}
                  </div>
                  <div className="px-4 py-2 text-sm text-gray-700">{user.email}</div>
                  <button
                    onClick={handleSignOut}
                    className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 text-red-600"
                  >
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </div>
          
        </header>

        {/* Page Content */}
        <main className="p-4 flex-1 md:p-2">
          <Outlet />
        </main>
        <footer
          className={`fixed p-6 bottom-0 left-0 w-full bg-gray-800 text-white text-sm h-10 flex items-center justify-center z-50 relative`}
          aria-label="footer"
          >
          <div className="max-w-7xl w-full text-center truncate">
          © 2025 Mxm Finance 2. All rights reserved.
          </div>
        </footer>
      </div>
    </div>
  );
};

export default DashboardLayout;
